import APIFetcher from '../APIFetcher';

class LessonSparkViewRecordApi {
  static getLessonSparkViewRecords() {
    return APIFetcher.get('lesson-spark-view-record');
  }
}

export default LessonSparkViewRecordApi;
